<template>
  <div
    class="card mb-5 mb-xl-10"
    id="profile_details_view"
  >
    <!--begin::Card header-->
    <div class="card-header cursor-pointer">
      <!--begin::Card title-->
      <div class="card-title m-0">
        <h3 class="fw-bolder m-0 fs-4 text-gray-800">
          {{ translate("Details") }}
        </h3>
      </div>
      <!--end::Card title-->

      <!--begin::Action-->
      <add-user
        userId="userId"
        :customer="customer"
        @closeModal="closeModal"
      />
      <!--end::Action-->
    </div>
    <!--begin::Card header-->

    <!--begin::Card body-->
    <div class="card-body p-9">
      <div class="row mb-7">
        <div class="col-lg-4">
          <span class="col-lg-4 fw-bold text-muted">{{
            translate("logo")
          }}</span>
        </div>
        <div class="col-lg-8">
          <div
            class="image-input image-input-outline"
            data-kt-image-input="true"
            style="background-image: url(media/avatars/customer.jpg)"
          >
            <!--begin::Preview existing avatar-->
            <div
              class="image-input-wrapper w-125px h-125px"
              :style="
                imgPath === null
                  ? 'background-image: url(media/avatars/customer.jpg)'
                  : `background-image: url(${imgPath})`
              "
              style="background-size: 100% 100%"
            ></div>
            <!--end::Preview existing avatar-->

            <!--begin::Label-->
            <label
              class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
              data-kt-image-input-action="change"
              data-bs-toggle="tooltip"
              :title="t('user_detail_edit_change_avatar')"
            >
              <i class="bi bi-pencil-fill fs-7"></i>

              <!--begin::Inputs-->
              <input
                type="file"
                name="avatar"
                accept=".jpg, .jpeg, .png"
                @change="selectImage($event)"
              />
              <input
                type="hidden"
                name="avatar_remove"
              />
              <!--end::Inputs-->
            </label>
            <!--end::Label-->

            <!--begin::Remove-->
            <span
              class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
              data-kt-image-input-action="remove"
              data-bs-toggle="tooltip"
              @click="removeImage($event)"
              :title="t('user_detail_edit_remove_avatar')"
            >
              <i class="bi bi-x fs-2"></i>
            </span>
            <!--end::Remove-->

            <span
              v-show="customer.LogoPictureUrl !== imgPath"
              class="btn bg-success btn-icon btn-circle btn-color-white w-35px h-35px bg-white shadow"
              style="top: -10px; left: -10px"
              data-kt-image-input-action="remove"
              data-bs-toggle="tooltip"
              @click="saveImage()"
              :title="t('user_detail_edit_save_avatar')"
            >
              <i
                class="bi bi-check"
                style="font-size: x-large"
              ></i>
            </span>
          </div>
        </div>
      </div>

      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">{{
          translate("customer_detail_label_name")
        }}</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bold fw-bolder fs-6 text-dark">{{
            customer.Name
          }}</span>
        </div>
      </div>

      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">{{
          translate("customer_detail_label_personel")
        }}</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bold fs-6 text-gray-800"
            >{{ customer.Firstname }} {{ customer.Lastname }}</span
          >
        </div>
        <!--end::Col-->
      </div>
      <!--end::Input group-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">
          {{ translate("customer_detail_label_contact_phone") }}
          <i
            class="fas fa-exclamation-circle ms-1 fs-7"
            title="Phone number must be active"
          ></i>
        </label>

        <div class="col-lg-8 d-flex align-items-center text-gray-800">
          <span class="fw-bold fs-6 me-2">{{ customer.PhoneNumber }}</span>
        </div>
      </div>
      <!--end::Input group-->

      <!--begin::Input group-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">{{
          translate("customer_detail_label_email")
        }}</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <a
            :href="`mailto:${customer.Email}`"
            class="fw-bold fs-6 text-gray-800 text-hover-primary"
            >{{ customer.Email }}</a
          >
        </div>
        <!--end::Col-->
      </div>
      <!--end::Input group-->

      <!--begin::Input group-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">
          {{ translate("customer_detail_label_country") }}
        </label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{
            customer.CountryName
          }}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Input group-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">{{
          translate("customer_detail_label_adress")
        }}</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <div class="row">
            <span class="fw-bold fs-6 text-gray-800">{{
              customer.Address
            }}</span>
          </div>
          <div class="row justify-content-end">
            <span class="fw-bold fs-6 text-gray-800"
              >{{ customer.CityName }} / {{ customer.DistrictName }}</span
            >
          </div>
        </div>
        <!--end::Col-->
      </div>
      <!--begin::Input group-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">{{
          translate("customer_detail_label_company_detail")
        }}</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bold fs-6 text-gray-900">{{
            customer.Description
          }}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--begin::Input group-->
    </div>
    <div class="d-flex justify-content-end p-5 pe-8">
      <!--end::Card body-->
      <button
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#add-customer-modal"
        class="btn btn-primary align-self-center btn-sm"
        @click="customerProfilEdit"
      >
        {{ translate("customer_detail_button_edit") }}
      </button>
    </div>
    <ConfirmPopup></ConfirmPopup>
  </div>
</template>

<script setup>
import { inject, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { useConfirm } from "primevue/useconfirm";
import AddUser from "@/components/Admin/Users/AddUser.vue";

const store = useStore();
const userId = ref("");
const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};
const confirm = useConfirm();

const customer = inject("customer");
const customerProfilEdit = inject("customerProfilEdit");
const updatedCustomerLogo = inject("updatedCustomerLogo");

const imgPath = ref(null);

let imgX = null;
const selectImage = (event) => {
  imgX = null;
  imgX = event.target.files || event.dataTransfer.files;
  if (!imgX.length) return;
  imgPath.value = URL.createObjectURL(imgX[0]);
};

const saveImage = async () => {
  let formData = new FormData();
  formData.append("CustomerId", customer.Id);
  formData.append("PictureFile", imgX[0]);
  let response = await store.dispatch(
    "CustomerModule/SET_CUSTOMER_LOGO",
    formData
  );
  if (response) {
    updatedCustomerLogo(customer.Id);
  }
};

const removeImage = (event) => {
  if (
    customer.LogoPictureUrl === imgPath.value &&
    customer.LogoPictureUrl !== null
  ) {
    confirm.require({
      target: event.currentTarget,
      message: translate("user_detail_confirm_delete_profile_image"),
      icon: "pi pi-exclamation-triangle",
      acceptLabel: translate("customer_location_confirm_acceptLabel"),
      rejectLabel: translate("customer_location_confirm_rejectLabel"),
      acceptClass: "btn btn-sm btn-primary",
      rejectClass: "btn btn-sm btn-light",
      accept: () => {
        store
          .dispatch("CustomerModule/DELETE_CUSTOMER_LOGO", customer.Id)
          .then((response) => {
            if (response) {
              updatedCustomerLogo(customer.Id);
            }
          });
      },
      reject: () => {
        return;
      },
    });
  } else {
    imgPath.value = customer.LogoPictureUrl;
  }
};

const closeModal = () => {
  userId.value = 0;
};
watch(customer, () => {
  if (customer.LogoPictureUrl !== null) {
    imgPath.value = customer.LogoPictureUrl;
  } else {
    imgPath.value = null;
  }
});
</script>

<style></style>
